import { render, staticRenderFns } from "./InventoryLabResultEdit.vue?vue&type=template&id=5a0e0534"
import script from "./InventoryLabResultEdit.vue?vue&type=script&lang=js"
export * from "./InventoryLabResultEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports